import React from "react";

const CustomCloseButton = ({ closeToast }) => {
  return (
    <button
      onClick={closeToast}
      className={`text-notificationText absolute right-2 top-1/2 mx-auto flex h-6 w-6 -translate-y-1/2 transform items-center justify-center text-xl hover:opacity-50`}
    >
      ✖
    </button>
  );
};

export default CustomCloseButton;
